import { useQuery } from '@tanstack/react-query';
import type { PaginatedList } from '../../../models/common/paginated-list.model';
import type { MonthlyReportDto } from '../../../models/taxes/monthly-reports.dto';
import apiRequest from '../../../services/apiWrapper';
import { createPaginatedQueryKeys } from '../../../services/createPaginatedQueryKeys';
import { MONTHLY_REPORTS_URL } from '../../../utils/constants/urlConstants';

async function fetchMonthlyReports(
  taxType: number,
  searchParams: URLSearchParams
) {
  const response = await apiRequest.get<PaginatedList<MonthlyReportDto>>(
    `${MONTHLY_REPORTS_URL}?reportPaymentType=${taxType}&${searchParams.toString()}`
  );

  return response.data;
}

function createQueryKey(taxType: number, searchParams: URLSearchParams) {
  return {
    type: taxType,
    ...createPaginatedQueryKeys(searchParams),
  };
}

export function useGetMonthlyReports(
  taxType: number,
  searchParams: URLSearchParams
) {
  return useQuery({
    queryKey: ['monthly-reports', createQueryKey(taxType, searchParams)],
    queryFn: () => fetchMonthlyReports(taxType, searchParams),
    enabled: taxType === 1 || taxType === 2,
  });
}
